/*
 * Import common js to use common function in this javascript file
 */
import { deleteConfirmationAlert } from "./common";
import { searchByTableColumns } from "./common";

/**
 * Tables store
 */
window.$(".saveTables").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.saveTables').attr('disabled', 'disabled');
    window.axios({
            method: "post",
            url: window.$(".tablesForm").attr('action'),
            data: window.$(".tablesForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);

        })
        .catch(function(error) {
            window.$('.saveTables').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.toastr.error(error.response.data.message, error.response.statusText);
            }
        });
    return false;
});

/**
 * Tables update
 */
window.$(".updateTables").on('click', function(e) {
    e.preventDefault();
    window.$(".error").html('');
    window.toastr.remove();
    window.$('.updateTables').attr('disabled', 'disabled');
    var thisCheckbox = window.$(this);
    window.axios({
            method: "PUT",
            url: window.$(".tableUpdateForm").attr('action'),
            data: window.$(".tableUpdateForm").serialize(),
        })
        .then(function(response) {
            window.toastr.success(response.data.message, response.statusText);
            setTimeout(function() {
                window.location = response.data.redirectTo;
            }, 1000);
        })
        .catch(function(error) {
            window.$('.updateTables').removeAttr('disabled');
            if (error.response.status == 400) {
                window.$.each(error.response.data, function(key, value) {
                    window.$('#' + key + '-error').text(value[0]);
                });
            } else if (error.response.status == 500) {
                window.$("input[name='status']:checkbox").prop('checked', true);
                window.toastr.error(error.response.data.message, error.response.statusText);
            } else if (error.response.status == 401) {
                window.toastr.error(error.response.data.message, error.response.statusText);
                // if(status == 'on'){
                //     window.$(t).prop('checked',false);
                // }else if(status == 'off'){
                //     window.$(t).prop('checked',true);
                // }
            }
        });
    return false;
});

/**
 * Tables table listing
 */

var table = window.$('.tablesTable').DataTable({
    "oLanguage": DATATABLE_LANGUAGE_OPTIONS,
    "aLengthMenu": [50,100,150],
    processing: true,
    serverSide: true,
    "ajax": {
        "url": window.$(".tablesTable").attr('link'),
        "type": "GET"
    },
    columns: [
        { data: 'id', name: 'id', "visible": false },
        { data: 'name', name: 'name' },
        { data: 'type', name: 'type' },
        { data: 'area', name: 'area' },
        { data: 'area_status', name: 'area_status' },
        { data: 'min_occupancy', name: 'min_occupancy' },
        { data: 'max_occupancy', name: 'max_occupancy' },
        { data: 'priority', name: 'priority' },
        { data: 'status', name: 'status', orderable: false, className: "status" },
        { data: 'widgetavailable', name: 'widgetavailable', orderable: false, className: "status" },
        { data: 'action', name: 'action', orderable: false, searchable: false },
    ],
    columnDefs: [{
        targets: [4, 5, 6, 7],

    }]
});

/**
 * Tables Delete
 */
window.$(document).on('click', '.deleteTables', function(e) {
    var currentObj = window.$(this);
    // Call method for delete confirmation
    var promise = deleteConfirmationAlert();
    promise.then(function(result) {
        // If confirmation true, do action for delete
        var myTable = $(".tablesTable").DataTable({
            bRetrieve: true,
            ajax: window.$(".tablesTable").attr('link')
        });
        e.preventDefault();
        window.axios({
                method: "DELETE",
                url: currentObj.attr('link')
            })
            .then(function(response) {
                myTable.ajax.reload();
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function(error) {
                window.toastr.error(error.response.data.message, error.response.data.statusText);

            });
        return false;

    }).catch(function(err) {
        console.log(err);
        return false;
    });

});

// change status of guest tag
window.$(document).on('click', '.tables_management .status_checkbox', function(e) {

    window.$(".error").html('');
    window.toastr.remove();

    var id = window.$(this).closest("tr").attr('id');
    var thisCheckbox = window.$(this);
    if (typeof id !== "undefined" && id !== '') {
        var status = (window.$(this).is(':checked')) ? 'on' : '';
        let t = window.$(this);
        var queryString = '/' + id;

        window.axios({
                method: queryString == '' ? "post" : "put",
                url: window.$(".tablesTable").attr('link') + queryString,
                data: {
                    'id': id,
                    'status': status,
                    'update_status': true
                }
            })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function(error) {
                if (error.response.status == 500) {
                    thisCheckbox.prop("checked", true);
                    window.toastr.error(error.response.data.message, 'Error');
                }else if (error.response.status == 401) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                    if(status == 'on'){
                        window.$(t).prop('checked',false);
                    }else if(status == ''){
                        window.$(t).prop('checked',true);
                    }
                }
            });

    }
});

// widget availability changes
window.$(document).on('click', '.tables_management .widget_availability_checkbox', function(e) {

    window.$(".error").html('');
    window.toastr.remove();

    var id = window.$(this).closest("tr").attr('id');
    var thisCheckbox = window.$(this);
    if (typeof id !== "undefined" && id !== '') {
        var status = (window.$(this).is(':checked')) ? 'on' : '';
        let url = window.$(this).attr('widgetAvailabilitylink');
        let t = window.$(this);
        var queryString = '/' + id;

        window.axios({
                method: queryString == '' ? "post" : "put",
                url: url,
                data: {
                    'id': id,
                    'availableforWidget': status,
                    'update_widget_availability': true
                }
            })
            .then(function(response) {
                window.toastr.success(response.data.message, response.statusText);
            })
            .catch(function(error) {
                if (error.response.status == 500) {
                    thisCheckbox.prop("checked", true);
                    window.toastr.error(error.response.data.message, error.response.statusText);
                }else if (error.response.status == 401) {
                    window.toastr.error(error.response.data.message, error.response.statusText);
                    if(status == 'on'){
                        window.$(t).prop('checked',false);
                    }else if(status == ''){
                        window.$(t).prop('checked',true);
                    }
                }
            });

    }
});

// Search in datatables of tables
window.$(document).ready(function() {
    // Setup - add a text input to each footer cell
    var excluded_columns = [8, 9, 10,11];
    searchByTableColumns(table, '#tableMngmt', excluded_columns);
});